<template>
  <div class="verse">
    <text-ref v-if="verse.ref && verse.ref.length > 0" :id="verse.ref" :text="verse.text"/>
    <text-with-refs v-else :text="verse.text"/>
    <div v-if="verse.stage_direction" class="stage-direction">
      <text-with-refs :text="verse.stage_direction.text"/>
    </div>
    <div class="number" v-if="number && verse.verse_index % 5 === 0">{{verse.verse_index}}</div>
  </div>
</template>
<script>
  import TextWithRefs from './TextWithRefs'
  import Ref from './Ref'
  import TextRef from './TextRef'

  export default {
    components: {TextRef, Ref, TextWithRefs},
    props: {
      verse: {type: Object, required: true},
      number: {type: Boolean, default: true}
    }
  }
</script>
<style lang="scss" scoped>
  .verse {
    display: flex;
    position: relative;

    .stage-direction {
      display: inline-block;
      margin-left: 1rem;
      font-style: italic;
    }

    .number {
      margin-left: auto;
    }
  }
</style>